import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { HOST_UPDATE_REVIEW } from "./actionTypes";
import { hostUpdateReviewDetailsSuccessful, hostUpdateReviewDetailsFailed, } from "./action";
import { postUpdateHostProductReview } from "../../../helpers/fakebackend_helper"
import { API_CODE } from '../../../helpers/enum'


function* hostUpdateProductReview({ payload: { user } }) {

    try {
        const response = yield call(postUpdateHostProductReview, user);
        if (response.statusCode === API_CODE.SUCCESS) {
            yield put(hostUpdateReviewDetailsSuccessful(response.data));

        } else {
            yield put(hostUpdateReviewDetailsFailed(response.message));
        }
    } catch (error) {
        yield put(hostUpdateReviewDetailsFailed(error));
    }
}

export function* watchOnHostUpdateReview() {
    yield takeEvery(HOST_UPDATE_REVIEW, hostUpdateProductReview);
}

function* HostUpdateReviewSaga() {

    yield all([
        fork(watchOnHostUpdateReview),
    ]);
}

export default HostUpdateReviewSaga;
